import Button from '@jbhi-fi/lanyard-ui/components/Button';
import { CTAProps } from './CTAButton';
import React from 'react';

export const CheckAvailability = ({ checkAvailabilityAction }: CTAProps) => {
  if (!checkAvailabilityAction) return null;
  return (
    <Button type="action" fullWidth onClick={checkAvailabilityAction}>
      Check Availability
    </Button>
  );
};
